export const parseCsvContent = (csvContent, t, language) => {
  let testQuestions = [];
  let error = null;

  try {
    const lines = csvContent
      .split('\n')
      .map((line) => line.trim())
      .filter((line) => line);
    if (lines.length > 0) {
      testQuestions = lines.map((line, nLine) => {
        const splitedLine = line.split(/[\t]+/);
        if (splitedLine.length === 6) {
          const correctAnswer = Number(splitedLine[splitedLine.length - 1]);

          if (
            Number.isNaN(correctAnswer) ||
            correctAnswer < 0 ||
            correctAnswer > 3
          ) {
            throw new Error(t('quizzes.correctAnswerNotAsNumber'));
          }

          return {
            question: [
              {
                languageCode: language,
                value: splitedLine[1],
              },
            ],
            ordinal: nLine + 1,
            answers: splitedLine.slice(2, -1).map((answer, index) => {
              return {
                answer: [
                  {
                    languageCode: language,
                    value: answer,
                  },
                ],
                correct: index + 1 === correctAnswer,
              };
            }),
          };
        }
        throw new Error();
      });
    }
  } catch (e) {
    testQuestions = [];
    error = e.message || t ? t('quizzes.malformedPasted') : e;
  }

  return { testQuestions, error };
};
